var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn"},[_c('van-button',_vm._b({class:_vm.getClassName,attrs:{"type":_vm.type},on:{"click":_vm.handleClick}},'van-button',_vm.$attrs,false),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }